import { atom } from 'jotai';

export const isCompleteVisibleAtom = atom<boolean>(false);
